/** Shared bits for the auth pages. */

export function AuthNotConfigured() {
  return (
    <div className="auth-page">
      <section className="question-card">
        <h2 className="question-card-title">Accounts</h2>
        <p>
          Sync is not configured on this deployment — your entire history lives on this
          device and everything keeps working as a guest.
        </p>
        <p className="muted">
          To enable accounts, the deployment needs <code>VITE_SUPABASE_URL</code> and{' '}
          <code>VITE_SUPABASE_ANON_KEY</code> (see <code>supabase/README.md</code>).
        </p>
      </section>
    </div>
  )
}

export function AuthError({ message }: { message: string | null }) {
  if (!message) return null
  return (
    <p className="drill-verdict wrong" role="alert">
      {message}
    </p>
  )
}
